<hr>
<div class="row">
  <div class="col-6 form-group">
    <label><strong>{{title}}</strong></label>
    <hr>
    <div *ngFor="let item of value" class="project">

      [{{item.businessUnit?.name}}] {{item.name}}&nbsp;<a *ngIf="edit" (click)="remove($any(item))" [routerLink]="[]">X</a>
    </div>
  </div>
  <div class="col-6" *ngIf="edit">
    <label><strong>Connect new Project</strong></label>
    <hr>
      <!--<input type="text" *ngIf="isExternal" [(ngModel)]="newParticipantName" class="form-control f
        
        
        
        
        
        
        orm-control-sm">-->
    <ngx-form-customer title="Customer" (valueChange)="updateBusiness($event)" [value]="$any(customer)"></ngx-form-customer>
    <div class="row">
      <div class="col-4">BU / Project</div>
      <div class="col-8">
        <ng2-completer *ngIf="!isExternal"
                       [(ngModel)]="newParticipantName"
                       [datasource]="projectService"
                       [minSearchLength]="0"
                       (selected)="select($event)"
                       [clearSelected]="true"
                       inputClass="form-control form-control-sm"
        ></ng2-completer>
      </div>
    </div>
    <hr>
  </div>
</div>
